import { ProfileFormField } from '../components/ProfileFormField';
import EntityFormProvider from '../EntityFormProvider';

export default function EstatePlanning() {
  return (
    <EntityFormProvider title="Estate planning">
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="last_reviewed_will"
        label="When did you last review your will?"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="has_power_of_attorney"
        label="Do you have appointed power of attorney?"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="power_of_attorney_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="has_started_inheritance_planning"
        label="Have you started inheritance planning?"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="started_inheritance_planning_info"
        label="More information (if applicable)"
      />
      <ProfileFormField entityType="EstatePlanning" fieldName="gift_record" label="Gift record" />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="charitable_contribution_record"
        label="Charitable contributions record"
      />
    </EntityFormProvider>
  );
}
